module.exports = __webpack_public_path__ + "media/img/frontend_application/myhosting/call-774fc83a9d73a65afcf93ace017d5ace.png";